import Cookie from 'js-cookie';
class ChannelService {
	constructor() {
		this.loadScript();
	}

	loadScript() {
		var w = window;
		if (w.ChannelIO) {
			return (window.console.error || window.console.log || function () {})('ChannelIO script included twice.');
		}
		var ch = function () {
			ch.c(arguments);
		};
		ch.q = [];
		ch.c = function (args) {
			ch.q.push(args);
		};
		w.ChannelIO = ch;
		function l() {
			if (w.ChannelIOInitialized) {
				return;
			}
			w.ChannelIOInitialized = true;
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.async = true;
			s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
			s.charset = 'UTF-8';
			var x = document.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
		}
		if (document.readyState === 'complete') {
			l();
		} else if (window.attachEvent) {
			window.attachEvent('onload', l);
		} else {
			window.addEventListener('DOMContentLoaded', l, false);
			window.addEventListener('load', l, false);
		}
	}

	boot(settings, callback) {
		window.ChannelIO('boot', settings, callback);
	}

	onBadgeChanged(callback) {
		window.ChannelIO('onBadgeChanged', callback);
	}
	
	shutdown() {
		window.ChannelIO('shutdown');
	}

	clear() {
		let domain = document.domain;
		if(/\.giftishow\.com$/.test(document.domain)) {
			domain = '.giftishow.com';
		}
		Cookie.remove('ch-session-67233', { path: '/', domain });
	}
}

export default new ChannelService();